import { QUESTION_TYPE__DATE } from '../../../constants';
import Question from '../Question';

export default class QuestionDate extends Question {
  constructor(doc) {
    super(doc);
    this.type = this.type || QUESTION_TYPE__DATE;
  }

  getExpectedValueType(fieldName) {
    if (
      (fieldName === 'value' || fieldName === 'other') &&
      this.settings &&
      this.settings.format
    ) {
      return { type: 'string', format: this.settings.format };
    }
    return super.getExpectedValueType(fieldName);
  }
}

QuestionDate.expectedValueType = {
  type: 'string',
  format: 'date',
};

QuestionDate.editorSettings = {};

Question.types[QUESTION_TYPE__DATE] = QuestionDate;
